import React from 'react';
import styled from '@emotion/styled';
import SectionHeadline from '../../../components/SectionHeadline';

import { useLocalization } from "gatsby-theme-i18n";
import AnimatedSection from '../../../components/AnimatedSection';
import Timetable from './Timetable';
import * as breakpoint from '../../../styles/breakpoints.module.scss';

const TimetableSection = ({ id, list, position, defaultVisual, type }) => {
  const { t } = useLocalization();

  return (<SectionWrapper id={`section_timetable_${id}`} className={`programTimetable ${type ? type : ''}`}>
  <AnimatedSection>
    <Content>
      <SectionHeadline title={t(`program_timetable.${id}.title`)} subtitle={t(`program_timetable.${id}.date`)} category={t(`program_timetable.${id}.subtitle`)} />
      <Timetable list={list} id={id} position={position} defaultVisual={defaultVisual} type={type} />
    </Content>
  </AnimatedSection>
</SectionWrapper>);
}
 
export default TimetableSection;

const SectionWrapper = styled.div`
  background:#F7F7FA;
  display:flex;
  align-items:center;
  position:relative;
  padding:96px 0;

  &.streaming{
    padding:0;
    .sectionHeadline{
      text-align:right;
      .category{
        font-size: 12px;
        line-height: 16px;
        margin-bottom: 4px;
      }
      .title{
        font-size: 28px;
        line-height: 36px;
      }
      .subtitle{
        font-size: 12px;
        line-height: 20px;
        margin-top: 4px;
      }
    }
  }
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 80px;
    min-height:728px;

    &.streaming{
      padding-top:32px;
      .sectionHeadline{
        text-align:center;
      }
    }
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    
    padding:32px 24px;
    min-height:0;

    &.streaming{
      .sectionHeadline{
        .category{
          font-size: 10px;
          line-height: 14px;
          margin-bottom:0;
        }
        .title{
          font-size: 20px;
          line-height: 28px;
        }
        .subtitle{
          font-size: 9px;
          line-height: 16px;
          margin-top:0;
        }
      }
    }
  }
  
`;
const Content = styled.div`
  width:100%;
  margin:0 auto;
  position:relative;
  overflow:visible;
  z-index:5;
  max-width: 1344px;
`
